import { AILevel } from '../ai';
import { BackgroundImageKey } from './imageKeys';

/**
 * 挑戦モードのステージ定義
 */
export interface ChallengeStage {
  /** ステージ番号（1〜9） */
  stageNumber: number;
  /** 敵モンスターID */
  enemyMonsterId: string;
  /** AIレベル */
  aiLevel: AILevel;
  /** ボスステージフラグ（Stage 9のみ true） */
  isBoss?: boolean;
}

/**
 * 挑戦モード全9ステージの定義
 */
export const CHALLENGE_STAGES: ChallengeStage[] = [
  { stageNumber: 1, enemyMonsterId: 'gardan', aiLevel: AILevel.LV1 },
  { stageNumber: 2, enemyMonsterId: 'morsu', aiLevel: AILevel.LV1 },
  { stageNumber: 3, enemyMonsterId: 'roona', aiLevel: AILevel.LV2 },
  { stageNumber: 4, enemyMonsterId: 'balga', aiLevel: AILevel.LV2 },
  { stageNumber: 5, enemyMonsterId: 'zephyr', aiLevel: AILevel.LV3 },
  { stageNumber: 6, enemyMonsterId: 'graon', aiLevel: AILevel.LV3 },
  { stageNumber: 7, enemyMonsterId: 'igna', aiLevel: AILevel.LV4 },
  { stageNumber: 8, enemyMonsterId: 'zaag', aiLevel: AILevel.LV4 },
  { stageNumber: 9, enemyMonsterId: 'erebos', aiLevel: AILevel.LV6, isBoss: true },
];

/**
 * ステージ番号からステージ情報を取得する
 */
export function getChallengeStage(stageNumber: number): ChallengeStage | undefined {
  return CHALLENGE_STAGES.find((s) => s.stageNumber === stageNumber);
}

/**
 * ステージ番号ごとのバトル背景マップ
 * ステージのボス/敵キャラのテーマに対応
 */
const CHALLENGE_STAGE_BG_MAP: Record<number, string> = {
  1: BackgroundImageKey.BATTLE,        // 巌巨人（岩の巨人）
  2: BackgroundImageKey.BATTLE_2,      // 太古翁（樹人）
  3: BackgroundImageKey.BATTLE_LUNA,   // 星詠霊（精霊）
  4: BackgroundImageKey.BATTLE_5,      // 金剛衛（玄武）
  5: BackgroundImageKey.BATTLE_7,      // 天翔（小型竜）
  6: BackgroundImageKey.BATTLE_6,      // 戦修羅（獣人）
  7: BackgroundImageKey.BATTLE_3,      // 紅蓮魔（炎の鳥）
  8: BackgroundImageKey.BATTLE_STATE8, // 衡騎士
  9: BackgroundImageKey.BATTLE_BOSS_1, // エレボス第1形態（第2形態はBattleSceneで切替）
};

/**
 * ステージ番号からバトル背景キーを返す
 * 範囲外の場合はデフォルト背景を返す
 */
export function getChallengeBgKey(stageNumber: number): string {
  return CHALLENGE_STAGE_BG_MAP[stageNumber] ?? BackgroundImageKey.BATTLE;
}

/**
 * クリア済みステージ数から次のステージ番号を返す
 * 全クリア時はnullを返す
 */
export function getNextStageNumber(clearedStages: number): number | null {
  const next = clearedStages + 1;
  if (next > CHALLENGE_STAGES.length) return null;
  return next;
}
